/* unplugin-vue-components disabled */import script from "./Contact.vue?vue&type=script&lang=ts&setup=true"
export * from "./Contact.vue?vue&type=script&lang=ts&setup=true"

import "./Contact.vue?vue&type=style&index=0&id=23ba51fa&lang=less&scoped=true"

import exportComponent from "/Users/crossle/Code/github.com/OneMornin/mornin.one/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ba51fa"]])

export default __exports__